import { getAllQueued, clearRequest } from '../utils/offlineDb';


export async function syncRequests(userId) {
  const queued = await getAllQueued();
  const ordersBatch = [];
  const ordersToRemove = [];
  const token = localStorage.getItem('accessToken');
  const tenant = localStorage.getItem('tenantId');

  // Prima fase: separa le richieste sugli ordini
  for (const req of queued) {
    if (
      req.url.includes('/orders') &&
      req.options?.method === 'POST' &&
      req.options?.body
    ) {
      try {
        const orderData = JSON.parse(req.options.body);
        const transformed = transformOrderForSync(orderData, req.timestamp);
        ordersBatch.push(transformed);
        ordersToRemove.push(req.id)
      } catch (err) {
        console.warn('[SYNC_REQUESTS] Errore parsing ordine da coda:', err);
      }
    }
  }

  // Seconda fase: sync batch ordini se ce ne sono
  if (ordersBatch.length > 0) {
    try {
      console.log(ordersBatch);
      const res = await syncOrdersBatch(ordersBatch, token, tenant);
      console.log('[SYNC_REQUESTS] Batch ordini sincronizzato:', res);

      for (const id of ordersToRemove) {
        clearRequest(id);
      }
    } catch (err) {
      console.error('[SYNC_REQUESTS] Errore nella sync batch:', err);
      // opzionalmente: potresti rimetterli in coda
    }
  }

  // Terza fase: invia tutte le altre richieste rimanenti
  for (const req of queued) {
    if (req.url.includes('/orders') && req.options?.method === 'POST') {
      continue; // già gestito nel batch
    }

    try {
      const response = await fetch(req.url, req.options);
      if (response.ok) {
        await clearRequest(req.id);
        console.log('[SYNC_REQUESTS] Richiesta sincronizzata:', req.url);
      } else {
        console.warn('[SYNC_REQUESTS] Errore nella richiesta:', req.url);
      }
    } catch (err) {
      console.error('[SYNC_REQUESTS] Errore fetch generico:', err);
    }
  }
}


export const syncOrdersBatch = async (orders, token, tenant) => {
  if (!token) console.warn('Token assente');
  const response = await fetch(`/api/sync/hub`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify({ orders }),
  });

  if (!response.ok) {
    if (response.status === 0) {
      throw new Error("Impossibile connettersi al server");
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }

  return await response.json();
};

function transformOrderForSync(orderData, timestamp) {
  return {
    tableId: orderData.tableId,
    createdAt: new Date(timestamp).toISOString(),
    status: 'OPEN',
    orderProducts: orderData.products.map(p => ({
      productId: p.productId,
      variantIds: Array.isArray(p.variantIds)
        ? p.variantIds
        : (p.variantId ? [p.variantId] : []),
      quantity: p.quantity,
      unitPrice: p.unitPrice ?? 0,
      discount: p.discount ?? 0
    }))
  };
}
